import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./EnrichedIcon.less";
import type { IEnrichedIconProps } from "./EnrichedIcon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 116 116"
    {...props}
  >
    <path
      fill="#D8FFFF"
      d="M58 109c28.167 0 51-22.833 51-51 0-28.166-22.833-51-51-51C29.834 7 7 29.834 7 58c0 28.167 22.834 51 51 51"
    />
    <path
      fill="#0597A3"
      d="M112.337 36.182a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"
    />
    <path
      stroke="#00D8D8"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={3}
      d="m105.799 13.438-9.994 9.992M105.799 23.43l-9.994-9.992"
    />
    <path
      fill="#00D8D8"
      d="M35.466 102.366a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7"
    />
    <path
      stroke="#00D8D8"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={3}
      d="M85.067 95v14.133M92.133 102.067H78"
    />
    <path
      stroke="#00D8D8"
      strokeMiterlimit={10}
      strokeWidth={2}
      d="M18.067 112.366a5 5 0 1 0 0-10 5 5 0 0 0 0 10Z"
    />
    <path
      fill="#0597A3"
      d="M76 47.001h33.354c1.461 0 2.646 1.161 2.646 2.59V64.41c0 1.43-1.186 2.591-2.646 2.591H76z"
    />
    <path fill="#001A43" d="M76 47H40v20h36z" />
    <path
      fill="#00D8D8"
      d="M6.795 47H40v20H6.795C5.252 67 4 65.773 4 64.263V49.738C4 48.227 5.253 47 6.795 47M58 27h33.405C92.837 27 94 28.139 94 29.541V47H58z"
    />
    <path
      fill="#0597A3"
      d="M24.629 27H58v20H22V29.574C22 28.154 23.178 27 24.629 27"
    />
    <path
      fill="#00D8D8"
      d="M58 67h36v17.413C94 85.841 92.817 87 91.358 87H58z"
    />
    <path
      fill="#0597A3"
      d="M22 67h36v20H24.67C23.195 87 22 85.829 22 84.386z"
    />
  </svg>
);
const SvgEnrichedIconBricksInverted = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IEnrichedIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("enriched-icon bds-enriched-icon", className, {
        ["bds-enriched-icon-" + size]: size,
        ["enriched-icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgEnrichedIconBricksInverted);
export default Memo;
